module.exports = __webpack_public_path__ + "img/four1.c59933fd.png";